import {
    NavController,
    ViewController,
    AlertController,
    LoadingController,
    Keyboard,
    Events,
    Platform
} from 'ionic-angular';
import {Component, ElementRef, AfterViewInit} from '@angular/core';
import {NavParams} from 'ionic-angular';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {Splashscreen} from 'ionic-native';
import {DomSanitizer} from '@angular/platform-browser';

// import {AccountKitPlugin} from '@ionic-native/cordova-plugin-accountkit';

import { CommonService } from "../../services/common.service";
import { TranslateService } from 'ng2-translate';



@Component({
    templateUrl: 'userEdit.html',
    selector: 'user-edit-page',
})
export class UserEditPage {
    private selectAction: string = "action1";
    //修改登录密码
    oldpwd: string;
    newpwd: string;
    newpwd2: string;
    //修改资金密码
    oldcheckpwd: string;
    newcheckpwd: string;
    newcheckpwd2: string;
    //修改昵称
    userNickname: string;
    userPhone: string;
    static userNickname: string;
    isCordova: boolean = true;
    verifyPhone: number;
    serveApi: string = "";

    responseCode: string = '';
    pageDome: HTMLElement;
    trustedUrl: any;
    loading:any;

    private flagToggleAccountTest: boolean;

    constructor(private sanitizer: DomSanitizer, 
        private translate: TranslateService,
        private platform: Platform, private params: NavParams, private keyboard: Keyboard, public loadingCtrl: LoadingController, private viewCtrl: ViewController, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public events: Events, public cs: CommonService,
                private el: ElementRef) {
        this.cs.userType > 1 ? this.flagToggleAccountTest = false : this.flagToggleAccountTest = true;
        this.pageDome = el.nativeElement;
        if(this.params.data.selectAction) {
            this.selectAction = "action3";
            this.userNickname = params.data.userData["nickname"];
            this.userPhone = params.data.userData["phone"];
            this.verifyPhone = params.data.userData["verifiedphone"];
        } else {
            this.userNickname = params.data["nickname"];
            this.userPhone = params.data["phone"];
            this.verifyPhone = cs.flagVerifyNumber;
        }
        if (this.platform.is('core') || this.platform.is('mobileweb')) {
            this.isCordova = false;
        }

        if (window.hasOwnProperty("serveApi")) {
            this.serveApi = window["serveApi"] + "images/download";
        } else {
            this.serveApi = "images/download";
        }

        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
        // Listen to message from child window
        let _this = this;

        // Define the event listener function separately
        const messageHandler = function(e) {
            if (e.origin === 'https://verify.loto188.com') {
                var key = e.message ? "message" : "data";
                var data = e[key];
                _this.confirmPhone(data);
            }
        };
        
        // Add the event listener
        window.addEventListener("message", messageHandler, false);
        
        // Later, when you want to remove the event listener
        window.removeEventListener("message", messageHandler);
        
    }

    presentLoading() {
        let url = 'https://verify.loto188.com/verifyphone?phone=' + this.userPhone;
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    ngOnInit() {
        this.presentLoading();
    }

    ionViewWillEnter() {
        //this.presentLoading();
    }

    editLoginFn() {
        let user = {
            oldpwd: this.oldpwd,
            newpwd: this.newpwd,
            newpwd2: this.newpwd2,
        };
        this.userService.editLoginPassWord(user, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.oldpwd = "";
                this.newpwd = "";
                this.newpwd2 = "";
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: this.translate.instant("THAY_DOI_THANH_CONG")
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    editPasswordFn() {
        let user = {
            oldcheckpwd: this.oldcheckpwd,
            newcheckpwd: this.newcheckpwd,
            newcheckpwd2: this.newcheckpwd2,
        };
        this.userService.editMoneyPassWord(user, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.oldcheckpwd = "";
                this.newcheckpwd = "";
                this.newcheckpwd2 = "";
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: this.translate.instant("THAY_DOI_THANH_CONG")
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    editNickNameFn() {
        let user = {
            userNickname: this.userNickname
        };
        this.userService.editNickName(user, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: this.translate.instant("THAY_DOI_THANH_CONG")
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
        this.events.publish('nickname:get', this.userNickname);
    }

    editPhoneFn() {
        let user = {
            userPhone: this.userPhone
        };
        let _this = this;
        var options = {
            useAccessToken: false,
            defaultCountryCode: "VN",
            facebookNotificationsEnabled: true,
            initialPhoneNumber: ["84", this.userPhone],
        };

        function success(params) {
            _this.confirmPhone(params["code"])
        }

        function failure(params) {
            if (params != 'User cancelled') {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: 'Xác thực không thành công! vui lòng thử lại.'
                });
            }
        }

        (<any>window).AccountKitPlugin.loginWithPhoneNumber(options, success, failure);

    }

    confirmPhone(code) {
        let param = {
            code: code
        };
        this.userService.confirmNumPhone(param, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Xác minh thành công!"
                });
                this.verifyPhone = 1;
                this.userPhone = data["phoneNum"];
                this.events.publish('phone:get', this.userPhone);
                this.events.publish('verifiedphone:get', this.verifyPhone);
                this.cs.flagVerifyNumber = 1;
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }


    ionViewWillLeave() {
        this.keyboard.close();
    }

    // ngAfterViewInit() {
    //     this.pageDome.querySelector('#getCodeVerify').addEventListener('change', (e)=>{
    //         this.confirmPhone(e.target["value"]);
    //     });
    // }
}



// WEBPACK FOOTER //
// ./src/pages/userEdit/userEdit.ts